import { Component, OnInit } from '@angular/core';
import { ChecklistService } from '../../services/checklist.service';
import { MessageService } from 'primeng';
import { StepType } from '../../interfaces/checklist/step-type';
import { ConfirmationService } from 'primeng/api';
import { TaskTypeService } from '../../services';
import { TaskStepDTO } from '../../interfaces/task-info';

@Component({
  selector: 'checklist-steps',
  templateUrl: './checklist-steps.component.html',
  styleUrls: ['./checklist-steps.component.scss'],
})
export class ChecklistStepsComponent implements OnInit {
  taskSteps: TaskStepDTO[] = [];
  stepType = StepType;
  stepTypeName: { [key: number]: string } = {};

  filterStepType?: number = null;
  filterTaskType?: number = null;
  filterIsCurrent?: boolean = null;
  filterIsPickup?: boolean = null;

  stepTypeOptions: { value?: any; label: any }[] = [];
  taskTypeOptions: { value?: number; label: string }[] = [];
  isCurrentOptions: { value?: boolean; label: string }[] = [];
  isPickupOptions: { value?: boolean; label: string }[] = [];
  filteredSteps: TaskStepDTO[] = [];

  constructor(
    public checklistService: ChecklistService,
    public confirmationService: ConfirmationService,
    public taskTypeService: TaskTypeService,
    public messageService: MessageService,
  ) {
    this.stepTypeOptions.push({ value: null, label: 'All Step Types' });

    Object.keys(StepType)
      .filter((key) => !isNaN(Number(StepType[key])))
      .sort((a, b) => a.localeCompare(b))
      .forEach((x) => {
        this.stepTypeName[StepType[x]] = x;

        this.stepTypeOptions.push({ value: StepType[x], label: x });
      });
  }

  async ngOnInit() {
    this.fetchTaskSteps().then(() => {});
    this.initFilters();
  }

  initFilters() {
    this.fetchTaskTypes().then(() => {});

    this.isCurrentOptions = [
      { value: null, label: 'All Statuses' },
      { value: false, label: 'Deleted' },
      { value: true, label: 'Active' },
    ];

    this.isPickupOptions = [
      { value: null, label: 'Pick-up + Drop-off' },
      { value: true, label: 'Pick-up' },
      { value: false, label: 'Drop-off' },
    ];
  }

  async fetchTaskSteps() {
    return this.checklistService.getTaskSteps().then((result) => {
      this.taskSteps = result;
      this.applyFilters();
    });
  }

  applyFilters() {
    console.log('FST ', this.filterStepType);
    console.log('FTT ', this.filterTaskType);
    console.log('FIC ', this.filterIsCurrent);
    console.log('FIP ', this.filterIsPickup);

    console.log('TSS ', this.taskSteps);

    this.filteredSteps = this.taskSteps.filter(
      (x) =>
        (this.filterStepType == null || x.stepType == this.filterStepType) &&
        (this.filterTaskType == null || x.taskType.id == this.filterTaskType) &&
        (this.filterIsCurrent == null || x.isCurrent == this.filterIsCurrent) &&
        (this.filterIsPickup == null || x.isPickUp == this.filterIsPickup),
    );
  }

  toggleCurrent(item: any) {
    this.confirmationService.confirm({
      message: 'Confirm you want to change the status of this task step?',
      header: 'Confirmation',
      icon: 'pi pi-question',
      accept: () => {
        item.isCurrent = !item.isCurrent;

        this.checklistService
          .patchTaskStep(item.id, { isCurrent: item.isCurrent })
          .then((result) => {
            this.fetchTaskSteps().then(() => {});
          });
      },
    });
  }

  private fetchTaskTypes() {
    this.taskTypeOptions = [{ value: null, label: 'All Task Types' }];

    return this.taskTypeService.get().then((result) => {
      result
        .sort((a, b) => a.name.localeCompare(b.name))
        .forEach((item) => {
          this.taskTypeOptions.push({ value: item.id, label: item.name });
        });
    });
  }
}
